import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { getCorrelationDelta } from 'nmr-correlation';
import { useCallback, useState } from 'react';
import Select from '../../../../elements/Select';
const moveLinkStyles = css `
  width: 100%;
  height: 100%;
  margin-top: 10px;
  text-align: center;

  p {
    font-size: 14px;
  }

  .selection-container {
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }

  button {
    flex: 2;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 5px;
    height: 30px;
    margin: 0 auto;
    margin-top: 15px;
    display: block;
    width: 60px;
    color: white;
    background-color: gray;
  }
`;
function getCorrelationLabel(correlation) {
    const delta = getCorrelationDelta(correlation);
    return `${delta ? delta.toFixed(2) : '?'}`;
}
function MoveLink({ correlationDim1, correlationDim2, link, correlations, onEdit, }) {
    const [selectedCorrelationIdDim1, setSelectedCorrelationIdDim1] = useState(correlationDim1.id);
    const [selectedCorrelationIdDim2, setSelectedCorrelationIdDim2] = useState(correlationDim2?.id || undefined);
    const getSelection = useCallback((correlation, dim) => {
        const selectionData = [];
        for (const correlation of correlations) {
            if (correlation.pseudo === false &&
                correlation.atomType === link.atomType[dim]) {
                selectionData.push({
                    value: correlation.id,
                    label: `${correlation.label.origin}: ${getCorrelationLabel(correlation)}`,
                });
            }
        }
        selectionData.push({
            key: 'new',
            value: 'new',
            label: `new -> ${(dim === 0
                ? getCorrelationDelta(correlationDim1)
                : getCorrelationDelta(correlationDim2)).toFixed(2)}`,
        });
        return (_jsx(Select, { onChange: (selection) => {
                if (dim === 0) {
                    setSelectedCorrelationIdDim1(selection);
                }
                else {
                    setSelectedCorrelationIdDim2(selection);
                }
            }, items: selectionData, defaultValue: correlation.id, style: {
                width: 110,
                height: 25,
                margin: 0,
                border: '1px solid grey',
            } }));
    }, [correlationDim1, correlationDim2, correlations, link.atomType]);
    return (_jsxs("div", { css: moveLinkStyles, children: [_jsx("p", { children: "Move of signals on either one or both axes." }), _jsx("p", { children: "\"New\" means to separate into a new row or column." }), _jsxs("div", { className: "selection-container", children: [getSelection(correlationDim1, 0), correlationDim2 && getSelection(correlationDim2, 1)] }), _jsx("button", { type: "button", onClick: () => onEdit(selectedCorrelationIdDim1, selectedCorrelationIdDim2), children: "Move" })] }));
}
export default MoveLink;
